import { useState } from "react";
import { useEvent } from "../../../context/EventContext";

// * Agenda is a component that displays the sub events of the selected event based on the location selected by the user.
//  * It also displays the day-wise sub events of the selected event.
//  * The user can select a location and view the filtered sub events based on the selected location.
//  * The user can also view the day-wise sub events of the selected event.
//  * The component takes in the selectedEvent state from the EventContext and displays the sub events accordingly.
//  * The component also handles the location dropdown and day-wise sub events button clicks.
//  * It filters the sub events based on the selected location and displays the day-wise sub events of the selected event.
//  * The component also handles the back button click to toggle the view between the location dropdown and day-wise sub events table.
const Agenda = () => {
  const { subEvents, locations, sponsors, speakers, types } = useEvent();
  const [selectedLocation, setSelectedLocation] = useState("");
  const [filteredSubEvents, setFilteredSubEvents] = useState([]);
  const [locationDropdown, setLocationDropDown] = useState(false);
  const [locationButton, setLocationButton] = useState(true);
  const [dayButton, setDayButton] = useState(true);
  const [daySection, setDaySection] = useState(false);
  const [backButton, setBackButton] = useState(false);

  //   console.log(subEvents);

  //   * Handles the change event of the location dropdown.
  //   * Filters the sub events based on the selected location and sets the filteredSubEvents state.
  const handleLocationChange = (e) => {
    setSelectedLocation(e.target.value);
    const filtered = subEvents.filter(
      (subEvent) => subEvent.location.toString() === e.target.value
    );
    setFilteredSubEvents(filtered);
  };

  // * Given a sponsor id, returns the sponsor name associated with the id.
  // * If no sponsor is found, it returns an empty string.
  // * This function is used in the Agenda component to display the sponsor names
  // * in the day-wise sub events table.

  const getSponsorDetails = (sponsorId) => {
    const sponsor = sponsors.find((sponsor) => sponsor._id === sponsorId);
    return sponsor ? sponsor.company_name : "";
  };

  // * Given a speaker id, returns the speaker name associated with the id.
  // * If no speaker is found, it returns an empty string.
  // * This function is used in the Agenda component to display the speaker names
  // * in the day-wise sub events table.
  const getSpeakerDetails = (speakerId) => {
    const speaker = speakers.find((speaker) => speaker._id === speakerId);
    return speaker ? speaker.speaker_name : "";
  };

  //   * Given a registration type id, returns the registration type name associated with the id.
  //   * If no registration type is found, it returns an empty string.
  //   * This function is used in the Agenda component to display the registration type names
  //   * in the day-wise sub events table.
  const getRegistrationDetails = (registrationId) => {
    const type = types.find((type) => type._id === registrationId);
    return type ? type.typeName : "";
  };

  // * Handles the click event of the "Location" button.
  // * Sets the state of the component to show the location dropdown and hide the "Location" button,
  // * and also hides the "Day-Wise SubEvents" button and shows the "Back" button.
  const handleLocation = () => {
    setLocationButton(false);
    setLocationDropDown(true);
    setDayButton(false);
    setBackButton(true);
  };

  // * Handles the click event of the "Day-Wise SubEvents" button.
  // * Sets the state of the component to show the day-wise sub events table and hide the "Day-Wise SubEvents" button,
  // * and also hides the "Location" button and shows the "Back" button.
  const handleDay = () => {
    setDayButton(false);
    setLocationButton(false);
    setDaySection(true);
    setBackButton(true);
  };

  // * Handles the click event of the "Back" button in the day-wise sub events table.
  // * Resets the component state to show the location dropdown and the "Day-Wise SubEvents" button,
  // * and clears the selected location.
  const handleHome = () => {
    setBackButton(false);
    setDaySection(false);
    setLocationDropDown(false);
    setDayButton(true);
    setLocationButton(true);
    setSelectedLocation(false);
  };

  return (
    <div className="agenda-section-details">
      {subEvents.length > 0 ? (
        <>
          {locationButton && (
            <div>
              <h3>Click Here to view Agenda Location Based.</h3>
              <button className="add-space" onClick={() => handleLocation()}>
                Click Here
              </button>
            </div>
          )}

          {dayButton && (
            <div>
              <h3>Click Here to view Agenda Day Wise.</h3>
              <button className="add-space" onClick={() => handleDay()}>
                Click Here
              </button>
            </div>
          )}

          {locationDropdown && (
            <>
              <h3>Select the Location</h3>
              <select onChange={handleLocationChange}>
                <option value="">Select Location</option>
                {locations &&
                  locations.map((location) => (
                    <option key={location._id} value={location._id}>
                      {location.space_name}
                    </option>
                  ))}
              </select>
              {backButton && (
                <button className="add-space" onClick={() => handleHome()}>
                  Back
                </button>
              )}
            </>
          )}

          {daySection && (
            <>
              {backButton && (
                <button className="add-space" onClick={() => handleHome()}>
                  Back
                </button>
              )}
              <table>
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {subEvents.map((subEvent, index) => (
                    <>
                      <tr key={subEvent._id}>
                        <td>Day - {index + 1}</td>
                        <td>
                          Start:
                          {new Date(subEvent?.start).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}{" "}
                          - End:
                          {new Date(subEvent?.end).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                          <p>Event name : {subEvent?.title}</p>
                          <p>
                            {" "}
                            Sponsor name:
                            {subEvent?.sponsors
                              .map((sponsorId) => getSponsorDetails(sponsorId))
                              .join(", ")}
                          </p>
                          <p>
                            Speaker Name:{" "}
                            {subEvent?.speakers
                              .map((speakerId) => getSpeakerDetails(speakerId))
                              .join(", ")}
                          </p>
                          <p>
                            Registration Type:{" "}
                            {subEvent?.registration_types
                              .map((registrationId) =>
                                getRegistrationDetails(registrationId)
                              )
                              .join(", ")}
                          </p>
                          <p>
                            <span>Is Open For All: </span>
                            {subEvent?.isOpen === true ? "YES" : "NO"}
                          </p>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* Render the table if a location is selected and there are filtered subEvents */}
          {selectedLocation && filteredSubEvents.length > 0 ? (
            <>
              <table className="agenda-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubEvents.map((subEvent) => (
                    <tr key={subEvent._id}>
                      <td>
                        {new Date(subEvent.start).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}{" "}
                        -{" "}
                        {new Date(subEvent.end).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>
                        <p>{subEvent.title}</p>
                        <p>
                          {subEvent.sponsors
                            .map((sponsorId) => getSponsorDetails(sponsorId))
                            .join(", ")}
                        </p>
                        <p>
                          {" "}
                          {subEvent.speakers
                            .map((speakerId) => getSpeakerDetails(speakerId))
                            .join(", ")}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            selectedLocation && <h4>No events available for this location.</h4>
          )}
        </>
      ) : (
        <h3> Data Not Available</h3>
      )}
    </div>
  );
};

export default Agenda;
